import styled from 'styled-components';

// Import components
import { Button } from 'components/elements';

export const ButtonRecord = styled(Button)`
	svg {
		path {
			fill: ${({ theme, isProgramRecorded }) =>
				isProgramRecorded ? theme.popover.iconActive : ({ isDetails }) => (isDetails ? theme.gray : theme.popover.icon)};
		}
		path.recording_dot {
			fill: ${({ theme, isProgramRecorded }) =>
				isProgramRecorded ? theme.palette.error : ({ isDetails }) => (isDetails ? theme.gray : theme.popover.icon)};
		}
	}
`;
